module.exports = __webpack_public_path__ + "img/file-slash.7edf8418.svg";